
(function(){
var D=window.DAVIS||{};
var $=function(s,r){return (r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var body=document.body;
function setMenu(v){body.classList.toggle('menu-open',v)}
$$('[data-open-menu]').forEach(function(b){b.addEventListener('click',function(){setMenu(true)})});
$$('[data-close-menu]').forEach(function(b){b.addEventListener('click',function(){setMenu(false)})});
document.addEventListener('keydown',function(e){if(e.key==='Escape')setMenu(false)});

/* filtro menudeo */
function setFilter(f){
  $$('[data-chip]').forEach(function(c){c.setAttribute('aria-pressed',c.getAttribute('data-chip')===f?'true':'false')});
  $$('.card[data-brand]').forEach(function(c){c.hidden=!(f==='todos'||c.getAttribute('data-brand')===f)});
}
$$('[data-chip]').forEach(function(c){c.addEventListener('click',function(){setFilter(c.getAttribute('data-chip'))})});

/* navegación interna con scroll suave */
$$('[data-go]').forEach(function(a){
  a.addEventListener('click',function(e){
    var id=a.getAttribute('data-go'),el=document.getElementById(id);
    if(!el)return; /* otra página: sigue el enlace */
    e.preventDefault();
    var f=a.getAttribute('data-filter');if(f)setFilter(f);
    setMenu(false);
    setTimeout(function(){el.scrollIntoView({behavior:'smooth',block:'start'})},120);
  });
});
(function(){
  var m=location.search.match(/[?&]f=(todos|hugo|boss)/);
  if(m&&document.getElementById('menudeo')){
    setFilter(m[1]);
    setTimeout(function(){var el=document.getElementById('menudeo');el&&el.scrollIntoView({behavior:'smooth',block:'start'})},200);
  }
})();

/* carrito */
var bump=0;
function updateCount(){
  return fetch(D.cartJs,{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
    var n=$('#cartCount');if(n){n.textContent=c.item_count;n.style.display=c.item_count>0?'block':'none'}
    var i=$('#cartIcon');if(i){i.className=(++bump%2)?'bumpA':'bumpB';i.style.display='flex'}
  });
}
function addToCart(id,btn,label){
  if(btn.dataset.busy)return;btn.dataset.busy='1';
  fetch(D.cartAdd,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:Number(id),quantity:1})})
  .then(function(r){if(!r.ok)throw new Error('add');return r.json()})
  .then(updateCount)
  .then(function(){
    btn.textContent='✓ Agregado';btn.classList.add('ok');
    setTimeout(function(){btn.textContent=label();btn.classList.remove('ok');delete btn.dataset.busy},1600);
  })
  .catch(function(){
    delete btn.dataset.busy;
    window.location.href=D.cartUrl; /* respaldo */
  });
}
/* comprar ahora: agrega y va directo al pago */
function buyNow(id,btn){
  if(btn.dataset.busy)return;btn.dataset.busy='1';
  var t=btn.textContent;btn.textContent='Un momento…';
  fetch(D.cartAdd,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:Number(id),quantity:1})})
  .then(function(r){if(!r.ok)throw new Error('add');return r.json()})
  .then(function(){window.location.href=D.checkout||'/checkout'})
  .catch(function(){delete btn.dataset.busy;btn.textContent=t;window.location.href=D.cartUrl});
}
$$('[data-buy]').forEach(function(b){
  b.addEventListener('click',function(){var id=b.getAttribute('data-variant');if(id)buyNow(id,b)});
});
/* paquetes y encargo */
$$('[data-add]').forEach(function(b){
  b.addEventListener('click',function(){
    var id=b.getAttribute('data-variant');if(!id)return;
    addToCart(id,b,function(){return b.getAttribute('data-label')});
  });
});
/* menudeo: talla -> agregar */
$$('.card[data-brand]').forEach(function(card){
  var btn=$('[data-menudeo]',card),buy=$('[data-buy-m]',card),sel=null;
  function label(){return sel?'Agregar · talla '+sel.getAttribute('data-size'):'Elige tu talla'}
  function refresh(){btn.textContent=label();btn.classList.toggle('off',!sel);buy.classList.toggle('off',!sel)}
  $$('.sz',card).forEach(function(s){
    s.addEventListener('click',function(){
      $$('.sz',card).forEach(function(x){x.setAttribute('aria-pressed','false')});
      s.setAttribute('aria-pressed','true');sel=s;refresh();
    });
  });
  buy.addEventListener('click',function(){if(sel)buyNow(sel.getAttribute('data-variant'),buy)});
  btn.addEventListener('click',function(){
    if(!sel)return;
    addToCart(sel.getAttribute('data-variant'),btn,label);
  });
});
/* calculadora de encargo */
var eb=$('#encBox');
if(eb){
  var unit=+eb.dataset.unit,fee=+eb.dataset.fee;
  var money=function(n){return '$ '+n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})};
  var addBtn=$('#encAdd');
  function pick(o){
    $$('.opt',eb).forEach(function(x){x.setAttribute('aria-pressed',x===o?'true':'false')});
    var q=+o.dataset.qty,total=q*unit+fee;
    $('#encPieces').textContent=q+' piezas × $ '+unit;
    $('#encSub').textContent=money(q*unit);
    $('#encTotal').textContent=money(total);
    $('#encPer').textContent='$ '+Math.round(total/q)+' por pieza con todo incluido';
    if(o.dataset.variant)addBtn.setAttribute('data-variant',o.dataset.variant);
  }
  $$('.opt',eb).forEach(function(o){o.addEventListener('click',function(){pick(o)})});
  var first=$('.opt',eb);if(first)pick(first);
}
})();
